/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useContext, useEffect, useState } from 'react';
import {
  Box,
  Fab,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  useMediaQuery,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import { useForm } from 'react-hook-form';

import { Autocomplete } from '@material-ui/lab';
import OptionProductData from './OptionProductData';
import { useTemplate } from '../hooks';
import ListboxComponent from '../components/fields/ListboxComponent';
import { GlobalContext } from '../contexts';

export default function CollectiveItemForm({
  services,
  products,
  rentitems,
  addItem,
  words,
  classes,
  user,
  isRTL,
  setAlrt,
  isPurchase = false,
  issale,
}: any) {
  const [itemError, setItemError] = useState<any>(false);

  const [itemvalue, setItemvalue] = useState<any>(null);
  const [itemqty, setItemqty] = useState(1);
  const [items, setItems] = useState([]);

  const { register, handleSubmit, errors } = useForm();
  const {
    store: { minstock },
  } = useContext(GlobalContext);
  const itemRef: any = React.useRef();
  const { tempoptions } = useTemplate();

  const isMobile = useMediaQuery('(max-width:600px)');

  const [type, setType] = useState(2);
  useEffect(() => {
    if (type === 2) {
      setItems(services);
      setItemvalue(null);
    } else if (type === 1) {
      setItems(products);
      setItemvalue(null);
    } else if (type === 4) {
      setItems(rentitems);
      setItemvalue(null);
    }
  }, [type, services, products, rentitems]);
  useEffect(() => {
    const allitems = type === 2 ? services : type === 4 ? rentitems : products;
    setItems(allitems);
  }, [type]);

  const resetAll = () => {
    setItemqty(1);
    setItemvalue(null);
  };
  const addLocalItem = async () => {
    if (!itemvalue) {
      setItemError(true);
      if (!isMobile) itemRef.current.focus();
      return;
    }
    const itemdata = {
      ...itemvalue,
      itemqty,
      userId: user?._id,
    };
    addItem(itemdata);
    resetAll();
    if (!isMobile) itemRef.current.focus();
  };

  const name = type === 1 ? words.product : words.service;
  return (
    <Box
      display="flex"
      style={{
        flex: 1,
        margin: 5,
        borderRadius: 5,
        alignItems: 'center',
        flexDirection: isMobile ? 'column' : 'row',
      }}
    >
      <RadioGroup
        row={isMobile}
        aria-label="Views"
        name="views"
        value={type}
        onChange={(e: any) => setType(Number(e.target.value))}
      >
        <FormControlLabel
          value={2}
          control={<Radio color="primary" />}
          label={words.services}
        />
        {tempoptions?.products && (
          <FormControlLabel
            value={1}
            control={<Radio color="primary" />}
            label={words.products}
          />
        )}
        {tempoptions?.rentitem && (
          <FormControlLabel
            value={4}
            control={<Radio color="primary" />}
            label={isRTL ? 'تجهيزات' : 'Equipment'}
          />
        )}
      </RadioGroup>
      <Box display="flex" style={{ flex: 1 }}>
        <Grid container spacing={1}>
          <Grid xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={12} md={8}>
                <Autocomplete
                  autoSelect
                  size="small"
                  options={items}
                  ListboxComponent={ListboxComponent}
                  getOptionLabel={
                    (option: any) =>
                      `${isRTL ? option.nameAr : option.name} ${option.barcode}`
                    // `${isRTL ? option.nameAr : option.name}`
                  }
                  getOptionSelected={(option, values) =>
                    option._id === values._id
                  }
                  renderOption={(option) => (
                    <OptionProductData
                      isRTL={isRTL}
                      item={option}
                      isPurchase={isPurchase}
                      minstock={minstock}
                      price
                    ></OptionProductData>
                  )}
                  fullWidth
                  value={itemvalue}
                  onChange={(_, newValue: any) => {
                    setItemvalue(newValue);
                    if (newValue) {
                      setItemError(false);
                    }
                  }}
                  style={{ direction: isRTL ? 'rtl' : 'ltr' }}
                  classes={{ input: classes.smallFont }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="product"
                      name="product"
                      label={name}
                      error={itemError}
                      variant="outlined"
                      fullWidth
                      inputRef={(ref) => {
                        itemRef.current = ref;
                      }}
                      InputLabelProps={{
                        style: { fontSize: isRTL ? 16 : 13 },
                      }}
                    ></TextField>
                  )}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  name="qty"
                  onChange={(e: any) => setItemqty(Number(e.target.value))}
                  value={itemqty}
                  label={words.qty}
                  variant="outlined"
                  inputRef={register}
                  type="number"
                  error={errors.qty ? true : false}
                  margin="dense"
                  onFocus={(e) => e.target.select()}
                  inputProps={{
                    style: { textAlign: 'right', fontSize: 13, height: 13 },
                    inputMode: 'decimal',
                  }}
                  fullWidth
                />
              </Grid>
              <Grid item xs={2} md={1}>
                <Fab
                  style={{
                    marginLeft: 10,
                    marginTop: 5,
                    width: 36,
                    height: 36,
                  }}
                  color="primary"
                  onClick={handleSubmit(addLocalItem)}
                  title="Create new row"
                >
                  <AddIcon />
                </Fab>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
